
  
<script>
import PlaneApi from "@/services/plane-api";

export default {
  name: 'company',
  components: {},
  data() {
    return {
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},

        requestQuoteList:[],
        isRequestQuoteTableBusy:false,
        start:null,
        end:null,

        selectedRequestQuote:null,
        showModelBagsModal:false,

        requestQuoteListFields: 
            [
                { key:"timeStamp", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
               
                { key:"name", label: "",   sortable: false, tdClass:"font-weight-bold ",thStyle:"min-width:200px;"},

                { key:"companyName", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},


                { key:"plane", label: "",   sortable: false, tdClass:"font-weight-bold "},

                { key:"withQrCode", label: "QR Code",   sortable: false, tdClass:"font-weight-bold "},
                { key:"selectedBagTypes", label: "Types",   sortable: false, tdClass:"font-weight-bold "},




                { key:"campaignDate", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none", thStyle:"min-width:90px;" },


                // { key:"lastName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                // { key:"email", label: "",thClass:"text-center d-md-table-cell d-none",tdClass:"text-center d-md-table-cell d-none" },
                // { key:"phone", label: "",   thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
                // { key:"sectorActivity", label: "",   thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},


                // { key:"campaignDuration", label: "",   sortable: false, thClass:"text-left d-md-table-cell d-none",tdClass:"text-center d-md-table-cell d-none" },
                // { key:"existingBagsModel", label: "",   sortable: false, tdClass:"font-weight-bold ", thStyle:"min-width:120px;"},
                { key:"images", label: "",   sortable: false, tdClass:"font-weight-bold text-center ",  thClass:"text-center d-md-table-cell d-none",  thStyle:"min-width:120px;"},

                
                // { key:"sizeBags", label: "",thClass:"text-center d-md-table-cell d-none",tdClass:"text-center d-md-table-cell d-none" },
                // { key:"colorBags", label: "",thClass:"text-center d-md-table-cell d-none",tdClass:"text-center d-md-table-cell d-none",  },

                { key:"actions", label:""}
            ],
     
    };
  },

  mounted() {
    this.findRequestQuote()
  },

  watch:{
    start:function(){
        this.findRequestQuote()
    },
    end:function(){
        this.findRequestQuote()
    }
  },

  methods: {

    openModelBagsModal(item){
        this.selectedRequestQuote = item,
        this.showModelBagsModal = true
    },

    findRequestQuote(){
        this.isRequestQuoteTableBusy = true;
        PlaneApi.findRequestQuote(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.start , this.end).then(
                response => {
                    if(response) {
                    this.requestQuoteList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                }   
                }
            )
            .finally(() => {
            this.isRequestQuoteTableBusy = false;
      });
    },

  },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-4  pr-2">

                <b-form-group >
                <b-form-datepicker
                    v-model="start"
                    locale="fr"
                    label-no-date-selected="Date Début"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright
                    hide-header
                ></b-form-datepicker>
                </b-form-group>
            </div>
            <div class="col-lg-3 col-md-4 ">
                <b-form-group  >
                <b-form-datepicker
                    v-model="end"
                    locale="fr"
                    label-no-date-selected="Date Fin"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright                         
                    hide-header
                ></b-form-datepicker>
                </b-form-group>
                
            </div> 

        </div>

        <div class="table-responsive mt-4"> 
                <b-table 
                :busy="isRequestQuoteTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="requestQuoteList"
                :fields="requestQuoteListFields"
                :perPage="pagemodelMain.perPage"
                class="table  "
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                <template v-slot:head(timeStamp)>
                    Date du Devis
                </template>
                <template v-slot:head(campaignDate)>
                {{ $t("requestQuote.table.head.campaignDate") }} 
                </template>
                <template v-slot:head(name)>
                {{ $t("requestQuote.table.head.name") }} 
                </template>
                <template v-slot:head(plane)>
                {{ $t("requestQuote.table.head.plane") }} 
                </template>
                <template v-slot:head(email)>
                {{ $t("requestQuote.table.head.email") }} 
                </template>
                <template v-slot:head(phone)>
                {{ $t("requestQuote.table.head.phone") }} 
                </template>
                <template v-slot:head(companyName)>
                {{ $t("requestQuote.table.head.companyName") }} 
                </template>
                <template v-slot:head(sectorActivity)>
                {{ $t("requestQuote.table.head.sectorActivity") }} 
                </template>
                <template v-slot:head(campaignDuration)>
                {{ $t("requestQuote.table.head.campaignDuration") }} 
                </template>
                <template v-slot:head(images)>
                {{ $t("requestQuote.table.head.images") }} 
                </template>
                <template v-slot:head(sizeBags)>
                {{ $t("requestQuote.table.head.sizeBags") }} 
                </template>
                <template v-slot:head(colorBags)>
                {{ $t("requestQuote.table.head.colorBags") }} 
                </template>

                <template v-slot:cell(name)="{item}">
                    <div class="text-dark font-weight-bold mb-1">
                        <span v-if="item.firstName">{{ item.firstName }}</span>
                        <span v-if="item.lastName"> {{ item.lastName }}</span>
                    </div>

                    <div>{{ item.phone }}</div>
                    <div>{{ item.email }}</div>
                    <div>{{ item.address }}</div>

                </template>
                    
                <template v-slot:cell(campaignDate)="{item}">
                    <div v-if="item.campaignDate" class="text-dark font-weight-bold mb-2">
                        
                        {{ item.campaignDate }}</div>
                    
                    <div>

                            <!-- <b-badge  href="#" variant="info" class="font-size-14 font-weight-bold ">
                                       {{item.campaignDuration == "+" ? ( item.customDuration + " "+ $t('requestQuote.day') ) : item.campaignDuration +" " + $t('requestQuote.week') }}
                            </b-badge> -->

                            

                        </div>
                </template>

                <template v-slot:cell(withQrCode)="{item}">

                    <b-badge v-if="item.withQrCode" href="#" variant="danger" class="font-weight-bold font-size-14">
                            QR Code
                    </b-badge>

                </template>

                
                <template v-slot:cell(selectedBagTypes)="{item}">
                    <div>
                        <b-badge v-for="(bagType, index) in item.selectedBagTypes" :key="index" href="#" variant="primary" class="font-weight-bold font-size-14 mr-1">
                            {{ bagType }}
                        </b-badge>
                    </div>
                </template>

                <template v-slot:cell(plane)="{item}">
                    

                    <div class="text-dark font-weight-bold mb-1">
                        <span class="text-dark font-size-14" v-if="item.bagsQuantity">{{ item.bagsQuantity }}</span>
                    </div>

                    <div class="text-info mb-3">
                        <div v-if="item.bagsPlane">Pack {{ item.bagsPlane }}</div>
                    </div>

                    <div class="mb-1" >
                        <b-badge v-if="item.sizeBags" href="#" variant="dark" class="font-size-14 mr-1 font-weight-bold">
                                    {{item.sizeBags}}
                        </b-badge>

                        <b-badge v-if="item.colorBags" href="#" variant="dark" class="font-size-14 ml-1 font-weight-bold">
                                    {{item.colorBags}} couleurs
                        </b-badge>
                    </div>

    

                </template>
                
                <template v-slot:cell(companyName)="{item}">
                    <div class="text-dark font-weight-bold mb-1" v-if="item.companyName">
                        <span v-if="item.companyName">{{ item.companyName }}</span>
                    </div>

                    <div class="text-info" v-if="item.sectorActivity">
                                    {{item.sectorActivity}}
                    </div>

                    

                </template>

                
    

                <template v-slot:cell(images)="{item}">
                    <img  v-if="item.images" alt="image"  width="20px" class="mr-2" fill="#fff" src="@/assets/icons/image.svg" style="cursor: pointer;" @click="openModelBagsModal(item)"/>
                </template>             
             
            
                </b-table>
                <span v-if="!isRequestQuoteTableBusy & !requestQuoteList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findRequestQuote()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isRequestQuoteTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findRequestQuote()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->


            <b-modal v-model="showModelBagsModal" v-if="selectedRequestQuote && selectedRequestQuote.images"
                hide-footer hide-header  centered size="lg">

                <div>
                    <span class="text-dark p-0 text-uppercase font-weight-bold "> {{ selectedRequestQuote ? selectedRequestQuote.firstName : "" }} </span>
                    <span class="text-dark p-0 text-uppercase font-weight-bold "> {{ selectedRequestQuote ? selectedRequestQuote.lastName : "" }} </span>
                </div>

                <div class="text-primary">
                    <span v-if="selectedRequestQuote.bagsPlane">{{ selectedRequestQuote.bagsPlane }}</span>
                    <span v-if="selectedRequestQuote.bagsQuantity"> ({{ selectedRequestQuote.bagsQuantity }})</span>
                </div>

                <b-card-img :src="'/api/image/get/' + this.selectedRequestQuote.images" style="border-radius: 5px;"></b-card-img>


    </b-modal>

    </div>
</template>
